module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch03"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("3")]), _vm._v(" "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("•")])]), _vm._v(" "), _c('h2', {
    staticClass: "chapterTitle",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("A Simple Act of Forgery")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterSubtitle",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Part 1")])]), _vm._v(" "), _c('div', {
    staticClass: "chapterEpigraph",
    staticStyle: {
      "margin-left": "0%"
    }
  }, [_c('p', {
    staticClass: "chapterEpigraphText",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("“One usually pays more dearly for the false than for the true, mademoiselle,” Lucien said.")]), _vm._v(" "), _c('p', {
    staticClass: "chapterEpigraphSource",
    staticStyle: {
      "margin-left": "0%"
    }
  }, [_vm._v("—"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("“The Great Cardhouse”")])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterEpigraph",
    staticStyle: {
      "margin-left": "0%"
    }
  }, [_c('p', {
    staticClass: "chapterEpigraphText",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("It was a phony though. That was why Tom preferred it.")]), _vm._v(" "), _c('p', {
    staticClass: "chapterEpigraphSource",
    staticStyle: {
      "margin-left": "0%"
    }
  }, [_vm._v("—"), _c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Boy Who Followed Ripley")])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterEpigraph",
    staticStyle: {
      "margin-left": "0%"
    }
  }, [_c('p', {
    staticClass: "chapterEpigraphText",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Honesty, for me, is usually the worst policy imaginable.")]), _vm._v(" "), _c('p', {
    staticClass: "chapterEpigraphSource",
    staticStyle: {
      "margin-left": "0%"
    }
  }, [_vm._v("—"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Patricia Highsmith")]), _vm._v(", 1960")])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("In the simple act of forgery—by no means her first or her last—committed in her thirty-fourth writer’s notebook in the spring of 1978, Patricia Highsmith pretended that it was April, that she was in London, and that she was making sketchy notes on an interview she had just completed with “one of the very few journalists I’ve ever liked!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Well, the first part was true enough.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Pat "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("had")]), _vm._v(" been in North London on 4 April, recuperating from her official duties at the Berlin Film Festival, alarming her friends with her behavior, and entertaining impolite thoughts about a journalist. Not the amiable young man she says she has just spoken to, but the intrusive woman who called to ask her opinion on the “man who [had just] knifed the Poussin in the National Gallery.”"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00000"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00000",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("1")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Disobliging behavior to members of the press—her little exercise in homeland defense—is nothing new for Pat Highsmith, who usually prefers to secure her borders "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("before")]), _vm._v(" she is invited to explore them by pushy journalists. On the long list of loathing she gleefully compiled during her thirty-five years of self-exile from the United States, “circling vultures” (her term for members of the press who want to write her biography) vies for pride of place with Women Who Remind Her of Her Mother. “Journalists,” she wrote scornfully. “I prefer prostitutes, who sell only their bodies, not their minds.”"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00001",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("2")])])]), _vm._v(" Every lengthy interview she has ever given to a journalist—and despite her reputation for reclusiveness, she has given many—has been marked by evasion, misdirection, and what could politely be construed as a distinct economy with the truth.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Of course, there are regular exceptions to Pat’s personal hate parade. She is pleased to have articles by the journalists and authors she respects (like Francis Wyndham, Noëlle Loriot, Julian Symons, and Josyane Savigneau) form the public perception of her work. And women who behave like her mother, Mary (not to mention Mother Mary herself), have been the bliss and bale of her life as a lover.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But here she is in the scented spring of 1978 writing that she’s in London, in April, in conversation with a journalist she likes, when in fact it’s May, and she’s back in her house in suburban France; alone with her disturbing emotions (love again, the feeling she most often confuses with murder or self-extinction) and enclosed in her customary habitat: a cone of watchful darkness.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("What’s more, she is poised on the edge of some very characteristic trouble with her new friend, the likeable journalist. It’s the kind of trouble that only an imagination as concentrated, as detailed, and as eccentric as Patricia Highsmith’s can produce.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Why Pat was forging entries in her notebooks, and what the slow roiling of her emotions was about to provide for a hapless member of the press, are important keys to the imagination of an author whose own character is as difficult to “undo” as the famous set of double-nested Bramah locks which forced the great Harry Houdini—an artist only sightly more obsessed with escape than Patricia Highsmith—into an unbecoming act of forgery himself."), _c('span', {
    staticClass: "endnoteRef",
    attrs: {
      "id": "fnt13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end02#fnt_13",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("*")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("On 22 March, thirteen days before her trip to London, Pat began a fortnight’s stay in Berlin as a jury member of the 1978 Berlin Film Festival. In what might have reminded her of her own partitioned imagination, the ten-foot-high depression-gray Berlin Wall, fancifully garnished with barbed wire, still divided this city on whose kinkier qualities the fifty-seven-year-old Pat had been taking desultory notes since August of 1976. Because she cast the net of her obsessions over everything she looked at, the Berlin of Pat’s cahier seems to be the setting for a Highsmith novel: it teams with people in disguise, violent inexplicable acts, and sudden odd affinities.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A “sturdy macho girl” in a lesbian bar pokes Pat in the ribs, declares she’s “not too soft,” then smashes her glass of vodka on the floor. Pat rather admires this gesture. She has been frequenting gay, lesbian, and transvestite bars like the Ax-Bax, Romy Haag, and Pour Ellen to save her “heart from the boring bourgeois” she is “otherwise surrounded by” at the film festival. She receives these small aggressions from her barmate as friendly overtures. Possibly she is influenced by the fact that the sturdy girl has already paid for her vodka.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A few snapshots from Pat’s infrequent visits to Germany (this was her fourth) live on in her archives. In two or three of them, she is grinning and appears to be almost at ease. She "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("is")]), _vm._v(" almost at ease—or in some vague relationship to that condition—and this anomaly is due to the presence of the other figures in the photos: a troupe of transvestites who have dolled themselves up for the camera in sequins, feathers, and more makeup than most people manage to apply in a year. Pat feels right at home with them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No wonder Berliners liked disguises!” she writes in the book that she will set partially in Berlin, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Boy Who Followed Ripley")]), _vm._v(". “One could feel free, and in a sense like "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("oneself")]), _vm._v(" in a disguise.”"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00003"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00002",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("3")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In public (private is another matter), Pat still tends to wear beautifully starched and ironed clothing—shirts, vests, and pants—which she still mail-orders from Brooks Brothers in the United States. She slips her feet into men’s black loafers whenever she can and accessorizes her “look” with what could be mistaken for her own version of transvestism: a scarf, a necklace, a bracelet, even a trace of lipstick.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In a photograph taken in the early 1940s in New York City by her friend the great photographer Ruth Bernhard, Pat looks attractively and impenetrably thoughtful. In other photographs from the same era by another friend, Rolf Tietgens, she seems to be provocatively and abstractedly "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("garçonne.")]), _vm._v(" Interpreted in her twenties in very different ways by two photographers who were competing for her attentions, Pat still manages not to give away a great deal.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Photographs of Patricia Highsmith at fifty-seven, however, are more likely to arrest than to attract. Her posture, as always, is braced against embarrassment, but her face seems to be involved in a furious rebellion against her oxford collars and her preppy, perfectly turned-back cuffs. Her eyes are heavily pouched now, the parabola of the jaw is swollen, and the provocative pout of her mouth in adolescence has given way to the pendulous lower lip of middle age. The ivory of her skin is creased, stained, and lined by her heavy drinking and smoking and—even worse for her complexion—by the violent ideas which have worked their way through her imagination. A thicket of bangs provides the cover through which she still looks up and out at the world with a remarkably sharp regard.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("At twenty, as Gabrielle Chanel famously said, you have the face you were born with. At fifty, you have the face you have earned.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In Paris restaurants, where French waiters are uncomfortably good at reading gender code, Pat is sometimes directed to the men’s lavatory.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Now, matter of fact, I am addressed as M’sieur so often it is quite disconcerting. Granted long hair doesn’t do much to make one look more feminine these days, I should think a touch of lipstick and a necklace would. No. I am halted from going into ladies’ rooms. ‘Not that door M’sieur!’ It’s enough to drive one mad.” "), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00004"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00003",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("4")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Pat thought that waiters stopped her “because I have big feet and skinny thighs.”"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00005"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00004",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("5")])])]), _vm._v(" She had to think something.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Certainly, there is room to speculate about who the “real” cross-dresser is in those photographs of Pat and her merry band of transvestites from the Fatherland. For the moment, it is enough to remember that Pat’s letters to her mother were filled with lists of clothing as specifically described as the costumes in her novels.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“People,” Pat notes, ever-hopeful on her nights out in Berlin that a quick change means a new life, “carry two changes of clothing for the evening.” She likes “the unreality of the city…,” its “end of the world quality,” the fact that it is “artifically maintained and is in danger of being abandoned.” Berlin in 1978 is definitely Highsmith Country.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But Pat was not writing her Berlin notes when she was in Berlin. She wrote up her notes—they continued to be the skeleton of every fiction she devised—when she was back at her house in Moncourt, after her short detour through London. She was weeks away from what she appeared to be writing about with such immediacy.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A pity,” she writes, confessing to her forgery like the good Dostoyevskyan she is, that “I didn’t keep a diary all those thirteen days.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("For the past forty years, chronological notation has been Patricia Highsmith’s lifeline; the increasingly fraying strand she follows compulsively through the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("un")]), _vm._v("chronological labyrinth she has made of her life. She began taking notes on herself, her ideas, and her surroundings at the age of fifteen or sixteen (she says twelve, but those notes are lost) when she was living with her family in Manhattan and acknowledging her unconventional emotions and the even more unconventional ways she found to accommodate them. Her obsessive intelligence quickly codified the note taking into two categories: her writer’s notebooks, to which she gives the slightly elevated term “cahiers” and which she uses as a seedbed for her fictions; and her personal “diaries,” the “journals” to which she confides the often extreme details of her intimate life.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The cahiers never vary, either in shape or form: they are always Columbia University or New York University notebooks (or notebooks identical in size to these) with firm boards, wire rolls to bind them, and lined pages. And, starting with Cahier 26, they always begin with a front-cover list of the places she has travelled to and they always end with an inside-the-back-cover list of the book titles she is considering. They are further divided into rigidly subtitled and heavily cultivated creative territories: “People and Places,” “Keime” (German for “germs,” a fertile term she lifted from Henry James), daily notes, favorite quotes, lengthy ideas for longer fictions, as well as “Notes on an Ever-Present Subject”: the rubric for her persistent musings on her own and everyone else’s homosexuality. Pat conscientiously maintained these categories in all her cahiers throughout her entire writing life.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sometimes Pat rehearses the motives for her prolixity in the cahiers, and sometimes she simply tries to deduce her motives from her actions. “But there must be a certain core of self-respect in a person who continuously keeps a diary. Maybe he doesn’t intend to look back, but someone else might, even if the diary is in code.”"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00006"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00005",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("6")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Code is the word for it. From her very first entries, Pat flogged herself into double duty by keeping her notebooks and diaries in five languages: serviceable English (or, rather, good American) in the main, but also ungainly French, bad Italian, awkward German, and a sprinkling of more or less strangled Spanish. (“I am so ambitious that I must telescope 2 separate ambitions—writing a diary and learning a language.”)"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00007"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00006",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("7")])])]), _vm._v(" Regularly, she mixes up which materials should go in which book (notebook or diary)—and then apologizes with the guilt of someone who feels her impulses to be so unruly that she just "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("has")]), _vm._v(" to corral them into the proper category.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Days, months, and years after she has filled up the pages of her cahiers and diaries, she continues to insert marginal comments, underlinings, and exclamation points. These remarkings and rereadings—from the vantage point of a self-critical present or an embittered future—ensure that Pat’s longest and most crucial conversations are always with herself: “This doesn’t get any point across. And furthermore it’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("weak")]), _vm._v("!”"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00008"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00007",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("8")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Occasionally, Pat the Part-Time Librarian takes up the pen and starts to cross-reference the material in the notebooks with the material in her diaries."), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00009"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00008",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("9")])])]), _vm._v(" She doesn’t want future readers of any of these confessional works to miss a trick or overlook an implication. And because she’s practical about what her imagination produces, and also because waste of any kind makes her angry, she likes to remind herself that there is yet plenty of useful material for fiction to be mined from these little life-books.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Still, any writer who keeps eight thousand pages of notebooks and diaries in five languages—four of which she has never mastered—and, what’s more, keeps them in a hand as difficult to decipher as a physician’s scrawl on a prescription pad, really does raise the question of just how much she wants people to know about what is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("in")]), _vm._v(" this mountain of pages she left behind. Pat’s family in Fort Worth used to labor over the “hieroglyphics” in her letters home, and even then, said her cousin Dan Walton Coates, they “couldn’t ever tell if she was saying that she was coming home on the seventeenth or leaving on the seventeenth!”"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00010"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00009",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("10")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Moreover, because Pat is committed to the principle that nothing is as it seems to be, and because she cannot allow herself to vacate her lifelong habit of keeping the chronological time (even when she is interrupting the chronological clock), she does just what her fictional characters do when "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("their")]), _vm._v(" “real” relations to the exterior world start to crumble.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She fakes it. She forges the dates and the places—long after she has lived through the times and the experiences—to make it appear that she has not turned her detailed, daily-kept notations into records which are more like memoirs than like chronicles. Gore Vidal, Pat’s fellow expatriate and occasional correspondent, makes a lucid distinction: a memoir, he writes, is “how one remembers one’s own life.”"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00011"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00010",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("11")])])]), _vm._v(" Memory is not history.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("For now, it is useful to note that a writer—especially a writer like Patricia Highsmith who is working in what she swears to you is her most explicit manner—can’t always be taken at her word.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("What has been engaging Pat about Berlin—aside from the link with her own shadowy Germanic paternal origins and the possibility of lucrative film and television contracts there"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00012"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00011",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("12")])])]), _vm._v("—is what interests her about everything: “the element of disguise,” the possibility of impersonation, of transformation, of forgery. But forgery, like the other shortcuts to transformation (murder, robbery, theft of identity, etc.) which occupy her imagination, has always been her favorite crime and strongest principle."), _c('span', {
    staticClass: "endnoteRef",
    attrs: {
      "id": "fnt14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end02#fnt_14",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("*")])])]), _vm._v(" Nestling just under the surface of her second Ripley novel, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ripley Under Ground")]), _vm._v(" (1970), is a convincing aesthetic argument in favor of forged art (Ripley prefers Bernard Tufts’s forged Derwatt painting to any original) and impersonated lives (Ripley himself impersonates the long-dead artist Derwatt). “I am afraid to say how much I like it,” Pat wrote when she finished the manuscript."), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00014"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00012",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("13")])])]), _vm._v(" One of her inspirations for the forgery business at the center of this book (Derwatt Ltd.) was the Dutch artist Hans van Meegeren’s successful counterfeiting of several Vermeer paintings during the late 1930s and early 1940s. Amongst van Meegeren’s happy customers was Hitler’s deputy, Herman Göring. Pat liked van Meegeren’s style.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("For a long time, Pat has been thinking about what she calls her “4th Ripley”—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Boy Who Followed Ripley")]), _vm._v("—a novel which will once again depend on forgery, the counterfeiting of identity, and even on the appearance of a youthful “copy” of Tom Ripley himself: sixteen-year-old Frank Pierson. By 1978, the year Pat is getting ready to finish this novel by slipping Ripley into a frilly party frock and designer heels and handing him a large handbag, forgery is as reflexive a reaction for her as it is for her characters.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Very soon now, Pat will start generating dozens of false names and fake identities—not one of which is meant for life in a Highsmith novel or short story. She creates these characters all through the 1980s and early 1990s in Switzerland, encourages them to write letters of “political opinion,” and then mails their urgent messages off (signature and handwriting disguised) to newspapers, journals, politicians, and state officials. It’s the same old Highsmith hand doing what it does best: counterfeiting identity. But in this case, Pat counterfeits with a purpose. She wants her forgeries to express her unrelenting hatred of the State of Israel.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Over the years, Pat managed to ventriloquize letters for at least thirty-eight “politically concerned” characters. “Edgar S. Sallich” from Locarno, “Isabel Little,” “Maria L. Leone,” “Janet Tamagni,” “Eddie Stefano,” “Elaine Dutweiler,” and “Phyllis Cutler” were among her most prolific pseudonyms, but Pat kept all her mouthpieces reasonably busy. Still, no one who reads the heat-seeking little missives these characters produced—and no one who counts up the myriad false names Pat needed to produce them—could ever imagine that her motives in this matter were entirely (or even predominantly) “political.”"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00015"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00013",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("14")])])])]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Pat’s arrival in Berlin on 22 March 1978 for the Berlin Film Festival was slightly shadowed by the fact that she failed to recognize Christa Maerker, the helpful friend who had come to pick her up at the airport. Pat and Christa, a German journalist and filmmaker, were introduced to each other on Pat’s last trip to Berlin. They got on “incredibly well and laughed through the evening,” then continued their friendship by correspondence when Pat went back to France. Christa was so impressed by Pat that she recommended her for the Berlin Film Festival jury; and the festival director “was thrilled” by the idea."), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00016"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00014",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("15")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But when Christa met Pat at the Berlin airport and tried to hug her, Pat, without a flicker of recognition, “became like a piece of wood,” leaned down, and whispered in her ear: “Please help me, I want to meet Christa Maerker.” “Still in a state of awe” about Pat’s work, Christa refused to believe Pat was drunk. But she noticed that when they reached the hotel Pat’s only request was for a bottle of scotch."), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00017"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00015",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("16")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Thirteen tumultuous days later when the festival was over, Pat had filched from her hotel room a blue and white bath mat embossed with two words and a date—“Hotel Palace…1973.” The mat was meant to be a souvenir of a newly kindled Berlin romance, but thirty years on it looks more like a symbol of the rituals she was using to control her anxieties: rigorous washing, the replacement of feelings with objects, and a compulsion to number her desires."), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00018"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00016",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("17")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Although Pat is only a working rumor in her native United States, she has been invited to this festival because of her European celebrity. Despite paralyzing shyness, she accepted the invitation because she is both professional about her work and alert to its perquisites, which sometimes include expenses-paid junkets to good hotels (like this one) in cities (like Berlin) where a writer (like herself) can gather useful material for a new novel.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When the festival showings begin, Pat finds that she is busier than she wants to be, trying to keep up with the (rather relaxed) twenty-three-film viewing schedule. She asks her translator friend, Anne Morneweg, to accompany her to the German-language films so she won’t miss any of the dialogue.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Predictably, Pat is unhappy at the festival—looking, as she has always looked in public, “uncomfortable with the proceedings,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("any")]), _vm._v(" proceedings. David Streiff, the director of the Locarno Film Festival, spotted Pat sitting “alone in a restaurant—a cheap and uncomfortable beer place right between the Zoo Palast and the Aeroflot offices. She impressed me strongly, through the strength and solitude she expressed—or better: the visible will to be left alone which she transmitted to everybody around.”"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00019"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00017",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("18")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Pat has reasons for her discomfort. She is being obliged to watch scenes of a sexual nature on film, while her usual preference is to cover her eyes during film sex and keep them open for film violence. When her irrepressible friend the seventy-five-year-old performance artist Lil Picard wrote to her from New York to praise some erotic films, Pat’s response was characteristic: “I don’t think I would enjoy these sex films. I have never seen any and have no curiosity about them. Maybe something is the matter with me. Of course a lot is the matter with me. But I have never enjoyed on the screen watching people petting or making love.”"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00020"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00018",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("19")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Worse, even, than having to watch sex on film was Pat’s selection as president of the Berlin Film Festival jury. It was a terrible idea.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Short on famous figures for the job of jury president, the festival elevated Pat to the office over her own objections—or so she wrote. She “tried to push [the honor off] on “Angelopoulos or Sergio Leone, but [had no] success.” She was modest enough to know that her film experience was insufficient to the occasion and canny enough to realize that even a “presidency” was too democratic an office for her to enjoy. She said later that her “simplest suggestions were thwarted,” but working with—or even in—a group of people was well outside Pat’s capacities. Very soon, the other jurors were unhappier with her presidency than she was. The reports filtering out from the committee meetings were not good: “She was usually half asleep, she never took notes, she never participated, she never took over the discussions, and [she even tried to change] the format by appointing someone else.” The director of the festival was forced to conclude, politely and privately: “We made a tremendous mistake.”"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00021"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00019",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("20")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And then, all of a sudden, just as it does in a Highsmith novel, something completely different broke into Pat’s Berlin experience. Something—as the writer and critic Susannah Clapp said about another feature of Pat’s fiction—that seemed to make its appearance from “another world.”"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00022"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00020",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("21")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Imagine—let’s have some fun with this—that an otherwise idle little devil, engaged by Hell’s Upper Management to plant crippling suspicions into the minds of working writers, has applied itself directly to the Problem of Patricia Highsmith. Perhaps this junior demon is something like the diminutive black figure with the harrowing laugh whose antic presence creates such havoc in Pat’s early satire, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Straightforward Lie")]), _vm._v(". Or perhaps it resembles the small, dark creature of her anxieties—the “Yuma baby”—which featured in her only attempt to write a “ghost” story: the brilliantly creepy “The Empty Birdhouse” (aka “The Yuma Baby,” written in September of 1966), a story prompted by Caroline Besterman’s admiration for the supernatural tales of M. R. James."), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00023"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00021",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("22")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And let us further imagine that Hell’s concentration on Pat Highsmith has produced something like the deranged little details of a typical Highsmith anecdote; the very elements which obsess her in her cahiers and diaries. “The chance meeting,” “the slightly tainted exchange of favors,” “the semisuppressed confession,” “the poison pen letter”—all of which, in their confusion of bad motive and good intention, could easily have been imported from anything Patricia Highsmith ever wrote.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In fact, this is exactly what happened to Pat at the Berlin Film Festival of 1978—without, perhaps, the active participation of Hell’s Executive Committee. And the complication of events that produced this tangle of woe demonstrates just how closely Pat’s life could resemble her work—and just how responsible she was for that resemblance.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sometime during her thirteen-day residence at the film festival, Pat Highsmith was “stopped in the street” by a stranger, a young Highsmith fan named Christopher Petit. (He was also a friend of David Streiff.) He was and is an English writer and journalist and he had, he says, been “watching her for several days.” “My behavior with her,” says Chris Petit, “was kind of uncharacteristic. [Accosting her on the street] is not something I normally would have done.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chris Petit is not the first or last Highsmith fan to find himself behaving “uncharacteristically” in Pat’s presence. Both Pat’s work and life exerted a sublunary pull on friends, fans, and lovers, who, against their better judgment, sometimes caught themselves acting just like characters in a Highsmith novel.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Pat’s lover in 1960–61, Marijane Meaker, was so driven by jealousy of a rival that she had to be talked out of committing a mail fraud that would have redirected all Pat’s mail to her own apartment for inspection. Undeterred, Meaker busily steamed open Pat’s letters when they lived together in Pennsylvania and took some secret peeks at Pat’s cahiers. Ellen Blumenthal Hill, Pat’s longtime partner in the kind of bad behavior obsessive love can inspire, found Pat’s diaries irresistible reading (until, that is, she read what Pat wrote about her); and Pat had to lock her teenage journals away from Mother Mary’s prying eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Marion Aboudaram, Pat’s current lover in Paris, first introduced herself to Pat with a straightforward lie. She said she had an assignment to interview Pat for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Cosmopolitan")]), _vm._v(" magazine. But Marion had no assignment. “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Cosmo")]), _vm._v(" didn’t ask me,” she says. “I decided it was a way to meet her.”"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00024"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00022",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("23")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A young friend of Pat—the kind of friend who painted Pat’s kitchen for free and went out to Moncourt to turn over the engine of Pat’s “awful metallic blue Simca” so the battery wouldn’t die when Pat was away (Pat managed to find many such friends)—was given a key to Pat’s house so she could use it in Pat’s absence. One time, when Pat was gone, the young woman opened the door to a photographer who was obsessed by Pat’s work, and the photographer took secret pictures of Pat’s personal possessions and of all the rooms in her house."), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00025"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00023",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("24")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("(Because the existence of these photographs is a violation of privacy, and because I took information from them for this book, I can now add my own name to the list of people inspired to behave badly by Patricia Highsmith.)")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A fervid fan of Pat’s novels in Paris, “an orphan of 21 who lives with his aunt” (he strongly identified with all the orphaned males in Pat’s work), was allowed to meet Pat in 1969. He immediately drove her mad: “He is so neurotic himself, it makes me feel almost normal,” she wrote to Lil Picard. “He gushes at me, praises me, until I want to scream.”"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00026"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00024",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("25")])])]), _vm._v(" Still, this fan, who knew all about cats, was allowed to select a seal-point Siamese kitten for Pat, and he and his aunt sometimes looked after Pat’s cats on her trips away. One night—the circumstances were complicated and involved a fight with her current lover, Jacqui—Pat ended up sleeping in the aunt’s bed, where, for once, Pat herself was on the receiving end of an unwelcome sexual advance."), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00027"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00025",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("26")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The list of aberrant activities by people under the sway of Patricia Highsmith—one way or another—is long and varied. Although on a good day her personal appeal was considerable, Pat did not have the kind of celebrity or, by now, the sort of looks which usually magnetize such antics. What the antics expose is the power of Pat’s work “to breed about her the world she created in her novels.”"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00028"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00026",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("27")])])]), _vm._v(" Pat conferred what all powerful writers confer upon their “friends and acquaintances: the vocabulary to describe life in [her] terms.”"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00029"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00027",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("28")])])]), _vm._v(" The related irony—that readers of Highsmith’s prose then imposed their Highsmith-inflected lives back upon "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("her")]), _vm._v("—caused Pat no end of trouble.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But she wasn’t troubled by her new acquaintance in Berlin, the journalist Christopher Petit. Quite the opposite.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In one of those numerical calculations she could never quite resist, Pat immediately reckoned that Petit had to be “about 28” years old. Her numbers were good: he was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("exactly")]), _vm._v(" twenty-eight, and he turned out to be the film critic for the London publication "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Time Out")]), _vm._v(". In the kind of unlikely coincidence usually found in a Highsmith work, Chris Petit’s own first film would be produced by Wim Wenders, the man who had just directed "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The American Friend,")]), _vm._v(" a film adaptation of two of Highsmith’s Ripley books: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ripley’s Game")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ripley Under Ground.")]), _vm._v(" (“He mingled two books for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("American Friend")]), _vm._v(",” Pat said tartly of Wenders’s adaptation.)"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00030"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00028",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("29")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Like the chance encounters in her stories, Highsmith’s meeting with this young journalist was familiar in its ordinariness. But it was also the kind of meeting with which she liked to ignite the spiralling paranoias of her murdering “hero-criminals.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Compliments were offered by Chris Petit. Miss Highsmith was “one of the two or three authors who mattered to him.” A favor was asked: he’d like to do an interview with her for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Time Out")]), _vm._v(". Perhaps, because Pat was canny about such things and intent on receiving good value for her investments, there was a little probing of mutual intentions on Pat’s part before the interview was actually granted. But she did grant an interview to Christopher Petit—and rather easily, too. She would be in London briefly, she told him, after the festival ended. He could see her there.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Pat was usually eager for publicity—her letters to editors are full of helpful suggestions for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("her")]), _vm._v(" kind of public relations, the kind that don’t get too close and ruin a writer’s workday—and she kept tabs on everything her publishers and agents did and didn’t do for her. But, like the title of one of her short stories, this encounter with the young journalist produced “nothing that meets the eye”—for now. For now, it was just one of those serendipitous meetings between hopeful youth and middle-aged achievement that punctuate the career of every successful writer.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("So Pat gave Chris Petit a number where she could be reached in North London (it was at the two Barbaras’ studio in Islington), and that was that. It was a leisurely beginning to a complicated episode—just the way she said she liked to start her novels.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I am inclined to write books with slow, even tranquil beginnings, in which the reader becomes thoroughly acquainted with the hero-criminal and the people around him.”"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00031"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00029",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("30")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Meanwhile, the film festival was in full swing and so were Pat’s most volatile feelings. Like Colette—whose work Pat once “defended” against an “attack” by the illustrious French writer Nathalie Sarraute during a Paris luncheon (Sarraute had maintained that Colette was too “feminine” for her; the much-younger Highsmith gathered the courage to disagree)"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00032"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00030",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("31")])])]), _vm._v("—Pat was still capable of the premonitory strike, of writing her own life before it happened. In the plots she has been notating for her “4th Ripley,” Tom is deeply and ambiguously attached to an attractively wealthy teenage boy. And Pat Highsmith, at fifty-seven years of age in the city of Berlin, has just been “bowled…over…knocked…mentally on the floor” by a twenty-five-year-old girl: an up-and-comer on Berlin’s avant-garde art circuit who enjoys slipping into male drag.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Tabea Blumenschein was the star of experimental director Ulrike Ottinger’s new film, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Madame X,")]), _vm._v(" and she had been Ottinger’s live-in lover for the last seven years. Pat’s feelings for Tabea, kindled on a previous trip to Berlin, flared up now at the festival, although Pat was still involved in her three-year-long relationship with the French novelist and translator Marion Aboudaram.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Tabea—deploying equal amounts of makeup and flair—liked to get herself up as both a louche boy and a flamboyant woman. As a boy, she was dark and sneering, with a disreputable mustache and an ear loop. Dressed as a woman, she was a glamorously assertive blonde whose S&M accoutrements were part of her impersonation.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("An enthusiastic participant in the sexual, social, and artistic experiments with which Berlin’s (and New York’s and Paris’s and London’s) art world amused itself in the late 1970s (“T. spoke often of the Berlin discos, the one-night-stands,” Pat wrote),"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00033"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00031",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("32")])])]), _vm._v(" Tabea was also an eclectic maker of art: she designed costumes, she painted and drew, she acted in films. Without her makeup—there is a pale photograph of her with an unadorned face, plump and puppyish and blinking into the sun—Tabea seems hardly to exist. Her face paint, her disco nights, and her elaborate rotations of dress and disguise and transformation were all raw materials for her fresh identities. It was half performance art, half character armor, and wholly fun for a twenty-five-year-old caught up in Berlin nightlife. If, that is, you didn’t think too deeply about what those impostures might be concealing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Pat always thought deeply about impostures and concealment, but for a woman like her—a woman in late middle age, profoundly repetitive in her habits, writing characters who were themselves obsessed with transformation—Tabea’s quick-change artistry and avant-garde glamour arrived as a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("coup de foudre")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Pat,” says Tabea Blumenschein,")]), _vm._v(" "), _c('div', {
    staticClass: "extract",
    staticStyle: {
      "margin-left": "0%"
    }
  }, [_c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("never had friends like me. Her women friends were always dressed the same, she never saw anyone change costume and appearance like me. She was excited by my changing of my appearance, she was always asking what I was wearing in letters."), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00034"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00032",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("33")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Pat’s courting habits, always a little unusual, were, with Tabea, strongly marked by her fetishes. As though she couldn’t quite distinguish between herself and Tabea (whose behavior in Berlin in the 1970s resembled Pat’s behavior in Manhattan in the 1940s), Pat often doubled the presents she bought for Tabea, purchasing one item for the young woman and a twin item for herself.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Amongst her gifts to Tabea were a “flick knife,” a wristwatch with a black face and no numerals, an odd mirror, and striped shirts that she insisted on calling “sailor clothes.” (They both liked sailors: Pat was first attracted to Tabea because she appeared as a sailor in a campy sailor film by Ulrike Ottinger, and Tabea, in the present day, still paints jaunty pictures of sailors.) Pat bought a mysterious object for which she paid “3 pounds liquid” and which she described to a perplexed Christopher Petit as a “Filthy Paperclip.” This object, mailed out to both Pat and Tabea with the label “Toy Airplane” on it, might have been an erotic toy, but Pat’s reference to it was so coy that its purpose was entirely obscured.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Despite her dislike of sex on film, Pat had always warmed to dirty jokes, filthy limericks (she was the author of many an unprintable verse), and vulgar descriptions. She liked to refer to the third French village she lived in, Montmachoux, as “Mount-my-shoe,” thus neatly connecting her distaste for the habits of dogs to a slur on her surroundings, and she always found verbal and visual jokes involving human sexual parts and bathroom habits hilarious. She happily described to friends a joke photograph she kept of a woman with one naked breast caught in a washing machine mangle (the photograph is excruciating to look at), captioned: “You think you’ve got problems?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In the book she’s writing now, her “4th Ripley,” Pat imagines Tom Ripley toying with the idea of acquiring the ultimate dirty joke: an inflatable doll wife and an inflatable doll mistress. Ripley, whose sexual instincts are perhaps most clearly expressed by his later bedtime readings of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Christopher and His Kind")]), _vm._v(" by Christopher Isherwood and Richard Ellmann’s biography of Oscar Wilde (Pat’s own bedtime reading), decides what Pat herself might have decided under the circumstances: that the rubber sex dolls are as threatening to him as “real” women are. “It would take all the breath out of a man” to blow those dolls up, Ripley thinks."), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00035"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00033",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("34")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In her most recently published work, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Edith’s Diary")]), _vm._v(" (1977), Pat made Edith’s son Cliffie, a character so unattractive that readers can feel the motives she had in creating him (Cliffie was suggested by a boy of whom Pat was both jealous and scornful; a boy she later compared to the cannibal Jeffrey Dahmer), fantasize about creating a doppelgänger of the woman who obsesses him. But what will he use? “The problem of the materials threw him off.”"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00036"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00034",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("35")])])]), _vm._v(" Pat’s male characters can rarely be bothered to have sex of any kind.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("During her thirteen days in Berlin, Pat’s courting habits followed the rules of revulsion as closely as they obeyed the laws of attraction. Her most inspired idea for a romantic outing with a woman thirty-two years her junior was to take Tabea Blumenschein to a place made memorable by the courting rituals of another species—the crocodile pen at the Berlin zoo."), _c('span', {
    staticClass: "endnoteRef",
    attrs: {
      "id": "fnt15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end02#fnt_15",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("*")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I shall remember the zoo, with its crocodiles, and Tabea leaning on a rail, on the left, gazing down into their heated pond. She remarked that they had wounded each other by their biting. True. The blood was visible.”"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00038"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00035",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("36")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Blood was usually “visible” when the talented Miss Highsmith fell in love. But from the onset of every love affair she was convinced that the blood would be her own. When Pat was Tabea’s age, she was phrasing love as something that would empty the blood from her body.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Tonight I want to rid myself forever of love, tear it out of me as I would a tick sucking my blood.”"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00039"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00036",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("37")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Pat burned, suffered, and died in love—and so, if they returned her feelings, did the women who loved her. Lynn Roth—her affair of a few separated weeks in 1953 and 1954—was someone whose pervasive influence she would compare to Tabea’s. For now, the battered veteran of many love wars, Pat was confining herself to liquids and modest hopes: “To laugh and have a beer with [Tabea]—that seems all I want in life just now.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    },
    attrs: {
      "id": "pg01"
    }
  }, [_vm._v("So she drinks floods of beer and visits the aquarium with Tabea (“her favorite,” Pat says), as well as those attractively bleeding crocodiles in their hot-water bath. Berlin’s distinctively double nature—two cities with opposing, “entirely artificial” governments, and it’s worth your life to breach the Wall that separates them—is newly attractive to Pat. And Berlin’s S&M nightlife, and the gratuitous sexual transformations of the artists who assist in it, cannot help but appeal to a writer who declared at the age of twenty: “We love either to dominate or to be mastered ourselves…. there is no love without some element of hate,” “nor a love without domination.”"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00040"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00037",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("38")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Unchanged in her inclinations since she first voiced those opinions, and an old if still somewhat naïve hand in these matters by now, Pat assessed Tabea as a girl who “need[s] a boss.” Tabea herself says: “I felt I couldn’t live in Berlin alone…. I was so young…. I couldn’t live [alone] like Pat was living.”"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00041"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00038",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("39")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("No one could live “like Pat was living” for long, not even Pat herself. Falling in love with Tabea was a catastrophe for her. Pat’s lover Marion Aboudaram witnessed the damage when Pat finally returned to Moncourt from Berlin and London:")]), _vm._v(" "), _c('div', {
    staticClass: "extract",
    staticStyle: {
      "margin-left": "0%"
    }
  }, [_c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Pat’s eyes were completely closed, she was trembling, she had drunk so much. All the time I gave her vitamins. All she did was drink milk and beer and eat oranges. Tabea and I both had blue-gray eyes and when she looked at mine, she almost swooned."), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00042"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00039",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("40")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("On 11 April, Pat wrote a plain little poem to Tabea to show just where this love was leading her. Pat was feeling the “strange impulse or desire”")]), _vm._v(" "), _c('div', {
    staticClass: "extract",
    staticStyle: {
      "margin-left": "0%"
    }
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("To throw myself into the nearest")])]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Body of deep water,")])]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("And drown.")])]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I am not trying to prove")])]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Anything to anybody.")])]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("This isn’t blackmail.")])]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I’d do it with a smile.")]), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00043"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00040",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("41")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Although she adored boats, fantasized many times about being a sailor, and ended the lives of several of her characters in “deep water,” Pat had always feared dying in water. “[T]he thought of drowning is very unpleasant to me,” she told a British journalist in 1987. Naturally, she hid this true fact from her interviewer (Duncan Fallowell) in a haze of misdirection; telling him that her health was “excellent” and that her only illness had been “five cases of the flu.” This, after a life of racking hypochondria, serious blood diseases (chronic anemia and clotting deficiencies), grave arterial maladies (Buerger’s disease), terrible problems with her teeth, and a very recent (1986) operation for lung cancer. She also left out the alcoholism, the anorexia, and the depression."), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00044"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00041",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("42")])])])]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("It’s 4 April, now, the morning of her interview with Chris Petit, the young journalist she met in Berlin. Pat left the film festival three days ago to go directly to London, bypassing her house in Moncourt. She writes that she is still “spinning” from the experience of spending time with Tabea Blumenschein. In London, Pat is staying once again at the Islington home of Barbara Ker-Seymer, the highly regarded avant-garde photographer of the 1920s and 1930s (when the avant-garde was still "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("en avant")]), _vm._v("), and Ker-Seymer’s companion, Barbara Roett. The two Barbaras met Pat in the 1960s at the Cagnes-sur-Mer home of Annie Duveen, a lesbian relation of the art authority Sir Joseph Duveen. Annie Duveen, Barbara Roett says, “was terrified of Pat and didn’t know why she was being swooped down on”: Pat could be as unsettling a houseguest as she was a hostess. But the Barbaras are as aware of Pat’s eccentricities as they are sympathetic to the volatility of her current state—which has yet to involve (as did the last “crush” Pat brought to their house, the young journalist Madeleine Harmsworth) reservoir-sized applications of alcohol, faked telephone calls, and the slamming of interior doors."), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00045"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00042",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("43")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chris Petit arrived in Islington to the crescent street where the Barbaras lived “early in the morning”—it was 11:00 "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("A.M.")]), _vm._v("—to find Pat already (or still) drinking beer. Right away they discovered a shared taste: “we both smoked the same untipped French cigarettes and she was impressed because I had some Boyars.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But Chris “found her sufficiently intimidating to make questions almost impossible to ask,” and Pat gave him a “rotten interview.” The talk was, he says, “of no consequence” except at the very end when Pat unexpectedly answered a question he put to her about her authorship of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Price of Salt,")]), _vm._v(" the pseudonymous “lesbian” novel she had never publicly claimed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Pat had always been anxious about being identified with "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Price of Salt,")]), _vm._v(" and she “stewed”—her word—terribly before and after publishing it. (See “"), _c('span', {
    attrs: {
      "href": "#/9780312303754_ch17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Les Girls: Part 1.")]), _vm._v("”) By now, she regularly denigrated the book, attacked her mother for revealing her as the author (Mary Highsmith had spilled the beans to her minister in Texas), and only with the greatest reluctance allowed it to be brought out under her own name in England in 1990. She had had some nervous exchanges in 1985 with Alain Oulman, her editor at Calmann-Lévy in Paris, about the security of her nom de plume Claire Morgan, fearful that her authorship of the work had been leaked in France. (It hadn’t, but the critics found “a Highsmith touch” in the book.)"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00046"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00043",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("44")])])]), _vm._v(" When Bloomsbury finally republished "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Salt")]), _vm._v(" in London in 1990 with the name “Patricia Highsmith” on the front cover, they altered the title of the novel to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Carol")]), _vm._v(". Some part of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Price of Salt")]), _vm._v(" always seemed to be in disguise.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The likely reason for Pat’s anxiety about the novel is the one she admitted to when she was writing it. She couldn’t bear the exposure. She also couldn’t resist the temptation of creating the work as a double forgery: in the novel she is both pseudonymous (she published under the name of Claire Morgan) and eponymous (she created the character of Therese from her own experience).")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Price of Salt,")]), _vm._v(" written in the richly figured language of pursuit, betrayal, and murder, trails elements of crime fiction but is most redolent of fairy tale. Its line of force, in Susannah Clapp’s felicitous phrase, is “a detection of the heart,” "), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00047"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00044",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("45")])])]), _vm._v(" and its central criminal act—homosexual love—is the only one the outlaw heroines get away with.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Salt")]), _vm._v("’s beginnings in the toy section of a department store are filled with crude salesgirls who surround the precocious, artistic Therese like “a pack of wolves” "), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00048"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00045",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("46")])])]), _vm._v("—a phrase Pat used in her notebook to describe her fellow coworkers at Bloomingdale’s department store during her cameo appearance there as a salesgirl in December of 1948. (See “"), _c('span', {
    attrs: {
      "href": "#/9780312303754_ch17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Les Girls: Part 1.")]), _vm._v("”) In a reimagining of what had actually happened to her, Pat makes one of the “wolves” steal the “bloody bag of meat” young Therese is saving for her dinner. (Pat’s contempt for working-class women is palpable in this book.) Therese is dressed ritually like a “doll” in a hand-stitched bloodred dress by a gnomelike coworker who tries to mother her. Later on, Therese is redressed in a snow-white gown—again she looks like a “doll”—by another mother: her soon-to-be-disappointed prospective mother-in-law. Therese is symbolically wounded (a cut on her leg which she staunches with Kotex) just before meeting Carol, the older Ice Queen, who steals her heart, spirits her away to a kind of castle in the suburbs, feeds her a milky potion (in which Therese can taste blood and bone), asks her three important questions, and then grooms her for a long connubial voyage across the United States in a car.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Therese is courted by several men and another woman, undergoes serious tests of moral courage, and is awarded every single thing her heart desires—including Carol, the Ice Queen, who gives up her daughter for Therese. (And how Pat must have enjoyed writing "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("that")]), _vm._v(".) Therese’s final reward is Pat’s own American Dream, slightly transmuted: a really good chance at becoming a famous stage designer and a large apartment on Madison Avenue with her much older lover.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Because "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Price of Salt")]), _vm._v(" is a Highsmith fairy tale, there are a few irregularities. The two heroines prefer each other to any of their attendant males (or females). The seesaw of their love balances itself on dominance and submission and teeters, refreshingly, back and forth between the two women. The power to say no (always stronger in Highsmith novels than the power to say yes) is slyly applied like an unexpected thumb to a grocer’s scale. Blood is in the corner of every smile, and sexual consummations are spied upon, recorded, and offered up as legal threats. The beautiful Carol keeps a gun in the glove box of her automobile. The odor of mother-daughter incest is everywhere.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Carol and Therese’s cross-country motor flight from a shadowy male pursuer is the centerpiece of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Price of Salt")]), _vm._v("—just as the months-long motor trip of Vladimir Nabokov’s brilliant hallucination, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lolita,")]), _vm._v(" is the spine which compresses the nerves of that novel—and their drive begins, as does Humbert’s with his Lo, as an unacknowledged and incestuous honeymoon. Throughout the book, Carol and Therese enact a parody of mother-daughter relations which, in its quieter way, is almost as unsettling as Humbert and Lolita’s awful caricature of father-daughter love.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Price of Salt")]), _vm._v(" is far less conventional in its distribution of justice than Nabokov’s tour de force. Nabokov’s characters all get what the mid-1950s thought they “deserved” for their behavior—an early and agonizing death, mostly, and no profit from their transgressive pleasures. (Only the reader is allowed to profit from Nabokov’s gorgeous prose.)")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Price of Salt,")]), _vm._v(" published three years before "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lolita")]), _vm._v(" appeared, is a homosexual love story with an almost happy ending and not, as Pat wrote in the 1990 preface to the edition bearing her name, what the literary code of the time required: a novel with an ending in which the characters “pay for their deviation by cutting their wrists, drowning themselves in a swimming pool, or by switching to heterosexuality.” "), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00049"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00046",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("47")])])]), _vm._v(" And its pseudonymous, eponymous author actually "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("fell in love")]), _vm._v(" with the character of Carol and with Carol’s relationship to Therese as she was writing about them—a far more subtle and artistic response than falling in love with Mrs. E. R. Senn, the well-dressed bourgeoise whose chance meeting with Pat was the “germ” of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Price of Salt.")]), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00050"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00047",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("48")])])]), _vm._v(" (See "), _c('span', {
    attrs: {
      "href": "#/9780312303754_ch17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Les Girls:” Part 1.")]), _vm._v(")"), _c('span', {
    staticClass: "endnoteRef",
    attrs: {
      "id": "fnt16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end02#fnt_16",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("*")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But on this spring morning in 1978, says Christopher Petit, Pat “did admit to me at the end that she had written "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Price of Salt")]), _vm._v(".” And then she made “me promise for about 15 minutes that I wouldn’t mention it in the interview or attribute it to her.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chris Petit thinks Pat made this unusual declaration “because I’d plied her with cigarettes” and “laid it on” about her work. A year or two ago, he’d managed to get hold of a xeroxed copy of her "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Plotting and Writing Suspense Fiction")]), _vm._v("—“It’s not easy to find,” Pat responded, grasping the fact that only a real Highsmith fan would go to that length to read her work—and Petit brought to the interview an American first edition of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Strangers on a Train")]), _vm._v(" for her to sign.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And that basically was the end of that,” says Mr. Petit, except for “some [of her] pretty wacky political views…. Until the question of the dictionary came up.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They were talking about Berlin and Petit remarked that “visiting East Berlin is less of a cultural shock” than going to London."), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00052"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00048",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("49")])])]), _vm._v(" Always happy to identify a flaw in any country she’d left behind (Pat had moved from England to France ten years before), Pat thought “that was the funniest remark I’d heard in a week. The people in London streets "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("do")]), _vm._v(" look scruffy, shabby, unwashed even…. Even Regent Street begins to look like Oxford Street.”"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00053"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00049",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("50")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chris, who had met Tabea through the film circles he frequented, mentioned that he was going back to Berlin shortly. And then it was Pat’s turn to pose a question: “In that case,” she said, “perhaps you can do me a favor.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Enthralled with the idea of herself as mentor (she continued to cherish some unsettling ideas about the education of the young), Pat wanted to improve her friend Tabea Blumenschein’s English vocabulary by purchasing a “German-English, English-German dictionary from Foyles, Schoeffler-Weis”"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00054"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00050",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("51")])])]), _vm._v("—as she described the tome two weeks later in a letter to Chris Petit’s editor at "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Time Out,")]), _vm._v(" a letter which suggested that her new friend, the engaging Mr. Petit, was perhaps an imposter and almost certainly a thief—and she wanted Chris to take the dictionary to Berlin and deliver it to Tabea. It was “quite clear” to Chris that Pat was “too mean to pay the postage.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was a very large dictionary.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I…had to not take half my luggage in order to take this dictionary. It was an extremely heavy dictionary. Extremely heavy…And it was pretty clear at the end of the interview that she’d very nicely signed my book but this was the price I was going to have to pay.”"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00055"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00051",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("52")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("So Chris Petit “lugged” the dictionary to Berlin and saw the producer he was supposed to see. And during the meeting, the subject of the dictionary came up somehow, and—that little Highsmithian coincidence again—the producer, who had worked with Wim Wenders on his Highsmith film, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The American Friend,")]), _vm._v(" said: “Oh I’m seeing Tabea next week and you can leave the dictionary with me.” And that’s what Chris Petit did, putting an end to the matter. Or so he thought. Then he “went back to London and forgot all about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Until, that is, a call came from his editor at "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Time Out.")]), _vm._v(" The editor, says Chris Petit, got directly to the point.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He’d had this strange letter from Highsmith, accusing me of being an impersonator, an imposter…Because I told her that I’d promised to deliver the dictionary for her and it had never turned up [at Tabea’s]…She was, she said, confused as to whether I’d had anything to do with "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Time Out")]), _vm._v(" or whether I’d made that up…. God knows what lengths she was going to go to.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But as a close and admiring reader of Highsmith for many years, Chris Petit thought he did know what lengths Pat was going to go with her bland, insinuating little letter to his editor about “Christopher Pettit ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("sic")]), _vm._v("], who interviewed me (with tape) Tuesday April 4…and seemed happy to do me this favour. The problem is, the dictionary has not arrived. Forgive me for being puzzled…. My London friends were unable to find him in the book.”"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00056"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00052",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("53")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Still, Petit has been puzzling “for years” about that parenthetical phrase “(with tape).” “I always thought that was the most damning aside,” he says, “the implication being that the interview was probably bogus but I had been prepared to trick myself up with a tape recorder to fool her into believing I was a journalist.”"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00057"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00053",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("54")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Writing an accusatory letter to an editor after an interview is an unusual thing to do, even for a writer like Pat whose short stories and novels drip with poison pens."), _c('span', {
    staticClass: "endnoteRef",
    attrs: {
      "id": "fnt17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end02#fnt_17",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("*")])])]), _vm._v(" (But she did it again when David Streitfeld interviewed her for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Washington Post")]), _vm._v(". See: “The Cake That Was Shaped Like a Coffin: Part 1.”)"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00059"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00054",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("55")])])]), _vm._v(" Petit thinks there was a “certain glee, perhaps even malice, at the thought of causing trouble. I think it’s pretty clear she thought I had run off with, dumped, or lost the dictionary and hadn’t owned up. I remember the editor at the time thinking the letter odd.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t suppose he’d had another like it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And the source of [her] confusion,” says Petit, “can actually be found in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Strangers on a Train.")]), _vm._v("”"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00060"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00055",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("56")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When Pat signed Chris Petit’s first edition of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Strangers on a Train")]), _vm._v(" at their little tête-à-tête in Islington, she made what was for her an unlikely error. Despite his giving her the correct spelling, and despite her own careful orthography, she misspelled Petit’s name, adding an extra "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("t")]), _vm._v(" to make it “Pettit.” (Perhaps it was a likely error after all: doubling was one of Pat’s deeper instincts.) That was how she wrote his name in her notebook; that was how she spelled it in the agitated letters she sent to her London friends and in the letter she sent to the editor of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Time Out")]), _vm._v(" about his employee, the newly criminalized Mr. Petit. Or rather, Mr. Petit’s newly criminalized double, “Mr. Pettit.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Pat’s methods of inquiry, under her normal operating modes (suspicion and doubt), were circumlocuitous at best. If she could help it, she never approached anything directly. Chris Petit wondered why she didn’t simply call "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Time Out")]), _vm._v(" magazine. “It was pretty easy to establish that I worked there.” Instead, “she had all her English friends scouring the phone book under the wrong spelling when they could have looked me up on the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Time Out")]), _vm._v(" masthead. If she hadn’t spelt my name wrong she could have saved herself a lot of trouble!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Six days after this little rent in the fabric of their relations occurred, the matter had been set to rights and Pat was convinced that Christopher Petit wasn’t an imposter. Everything was calm again in Highsmith Country. “I think she kind of lost interest when she discovered there was no dark mystery to the fate of the dictionary,” says Chris Petit."), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00061"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00056",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("57")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Anyway all is cleared up now,” Pat writes cheerily to Petit,"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00062"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00057",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("58")])])]), _vm._v(" thanking him for his call to her in France which explained the source of her confusion: her own bad spelling and Tabea’s failure to keep her appointment with the producer who was holding the dictionary for her. And she invites Chris Petit to give her a ring when she’s next in London. (He did so and had an unnerving beer with Pat and Tabea; Pat had forgotten he was coming, and she and Tabea were “resting” together in bed in television director Julian Jebb’s borrowed flat.) And then, palpably playing with fire, Pat and Chris start exchanging letters about the possibility of his optioning a certain novel of hers for film; a novel whose title could easily be the rubric for their recent, racking relations: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Tremor of Forgery")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In her subsequent letters to Petit, Pat, as she usually was with young professionals, was chatty, forthcoming, supportive, and determined to get her money’s worth out of the exchange. Remarking that Tabea had counted up his numerous film reviews, Pat cannily promoted one of her young protégées to another one:")]), _vm._v(" "), _c('div', {
    staticClass: "extract",
    staticStyle: {
      "margin-left": "0%"
    }
  }, [_c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("I wonder if your strenuous film-viewing activities will get you to the Edinburgh Festival? I hope so, as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Madame X")]), _vm._v(" is being shown there, and Tabea Blumenschein and her partner Ulrike Ottinger are invited…I hope Time-Out can give it a mention, at least."), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00063"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00058",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("59")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And so the surface ripples closed gently over the deep waters of Pat’s suspicions. But for six anxious days, Patricia Highsmith, awash in her overwhelming feelings for a much younger woman, nervous because she’d admitted her authorship of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Price of Salt")]), _vm._v(", gamely attempting to keep her life in line by a small but significant act of forgery in her cahier, and occupied with what she automatically assumed were the criminal pursuits of her new friend, the young journalist Chris Petit, snapped right back to her default emotional position; the position which had long since determined her vision of how she confronted the world:")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As an island of honesty in a sea of swindlers.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As a woman who always expected to be cheated.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As a writer who believed that everyone had something to hide.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Pat gave Therese in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Price of Salt")]), _vm._v(" and Howard Ingham in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Tremor of Forgery")]), _vm._v(" the suspicion on which this operating principle was founded: “All adults have secrets.” And all her murderers and escape artists live out its most extreme version. At moments of intolerable stress, they evacuate their identities, split off into Alter Egos, and re-create their personalities accordingly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Here is David Kelsey, the romantic psychopath with the double identity in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("This Sweet Sickness,")]), _vm._v(" Pat’s 1962 novel about the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("other")]), _vm._v(" love that dare not speak its name, summing himself up: “Call me Bill,” David said."), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00064"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00059",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("60")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And Tom Ripley, in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Boy Who Followed Ripley,")]), _vm._v(" costumed and made up as a woman and about to rescue a boy for whom he has an obvious attraction: “Don’t call me Tom.”"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00065"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00060",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("61")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And the affectless Ray Garrett, in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Those Who Walk Away,")]), _vm._v(" hiding from himself and plagiarizing Sartre: “I’m not Ray Garrett tonight. I haven’t been for days…. Perhaps identity, like hell, was merely other people.”"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00003_00066"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00003_00061",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("62")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In Highsmith Country, everyone—including the author—is a forger.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5b86e84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780312303754_ch03.vue
// module id = 78
// module chunks = 0